export const FETCH_TENANTMANAGERLOG_REQUEST = "FETCH_TENANTMANAGERLOG_REQUEST";
export const FETCH_TENANTMANAGERLOG_SUCCESS = "FETCH_TENANTMANAGERLOG_SUCCESS";
export const FETCH_TENANTMANAGERLOG_FAILURE = "FETCH_TENANTMANAGERLOG_FAILURE";
export const FETCH_TENANTMANAGERLOG_RESET = "FETCH_TENANTMANAGERLOG_RESET";
export const fetchTenantManagerlogRequest = (payload) => ({
    type: FETCH_TENANTMANAGERLOG_REQUEST,
    payload,
});
export const fetchTenantManagerlogSuccess = (payload) => ({
    type: FETCH_TENANTMANAGERLOG_SUCCESS,
    payload,
});
export const fetchTenantManagerlogFailure = (payload) => ({
    type: FETCH_TENANTMANAGERLOG_FAILURE,
    payload,
});
export const fetchTenantManagerlogReset = () => ({
    type: FETCH_TENANTMANAGERLOG_RESET,
});
